import { LEXON_API_URL } from 'src/config'
import { DocumentDb } from 'src/interfaces/EscritosLegales'
import { Document } from 'src/interfaces/lexon'
import lexonHttp from 'src/utils/Http/LexonHttp'

const DOCUMENT_LIST = `${LEXON_API_URL}/search`
const DOCUMENTS = `${LEXON_API_URL}/repository/documents/get`

const LEXON_DOCUMENT_ENTITY_TYPE_ID = 14
const LEXON_EXPEDIENT_ENTITY_TYPE_ID = 1

export async function searchDocuments(value: string, extAllowed: string): Promise<Document[]> {
  return lexonHttp
    .post({
      url: `${DOCUMENT_LIST}`,
      params: {
        searchTerm: value,
        extAllow: extAllowed.split(','),
        searchSource: [LEXON_DOCUMENT_ENTITY_TYPE_ID]
      }
    })
    .then(res => res.files.items)
}

export async function documentsByEntityType(
  idEntity: string,
  extAllowed: string,
  search?: string
): Promise<Document[]> {
  const params = {
    idEntity,
    idEntityType: LEXON_EXPEDIENT_ENTITY_TYPE_ID,
    searchTerm: search,
    filters: {
      extAllow: extAllowed.split(','),
      source: 'search'
    }
  }
  return lexonHttp
    .post({
      url: `${DOCUMENTS}`,
      params
    })
    .then(res => res)
}

export async function getDocument(document: Document): Promise<File> {
  const { id, initialFile } = document
  return lexonHttp
    .post({
      url: `${LEXON_API_URL}/repository/file/open/${id}/get`,
      headers: { Accept: '*', 'Content-type': '*' }
    })
    .then(blob => {
      return new File([blob], initialFile ?? 'errorName.pdf', { type: 'application/pdf' })
    })
    .catch(() => {
      return new File([''], 'emptyFile')
    })
}

export async function getDocumentData(documentId: number): Promise<DocumentDb | null> {
  return lexonHttp
    .post({
      url: `${LEXON_API_URL}/repository/document/${documentId}/get`
    })
    .then((data: DocumentDb) => {
      return data
    })
    .catch(() => {
      return null
    })
}
